import { render, staticRenderFns } from "./SchoolStaffPage.vue?vue&type=template&id=43da5464&scoped=true&"
import script from "./SchoolStaffPage.vue?vue&type=script&lang=js&"
export * from "./SchoolStaffPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43da5464",
  null
  
)

export default component.exports